module.exports = __webpack_public_path__ + "static/OP7-537cea4e0bb4fb5ba6c3f76d36086478.jpg";